export enum AdminPanelRoutes {
  ROOT = '',
  VERSION_INFO = 'version-info',
  USERS = 'users',
  GAMES = 'games',
  GENERATE_POST = 'generate-post',
  GAMES_STATS = 'games-stats',
  USERS_STATS = 'users-stats',
  FEATURE_FLAGS = 'feature-flags'
}
